module.exports = __webpack_public_path__ + "static/js/0.ff2b46d5.chunk.worker.js"